import { useEffect, useState } from 'react';
import tw from 'tailwind-styled-components';

interface BaseInputProps {
  hasError: boolean;
  dataType: 'text' | 'number';
}

const BaseInput = tw.input<BaseInputProps>`
block w-full bg-white text-xs
${(props) =>
  !props.hasError &&
  !props.value &&
  'border-none focus:border-green-500 focus:ring-green-500'} 
${(props) =>
  !props.hasError &&
  !!props.value &&
  'border-none focus:border-green-500 focus:ring-green-500'} 
${(props) =>
  props.hasError &&
  !props.value &&
  'border-none focus:border-green-500 focus:ring-green-500'} 
${(props) =>
  props.hasError &&
  !!props.value &&
  'border-red-300 focus:border-red-500 focus:ring-red-500 bg-red-100'} 
${(props) => props.dataType == 'number' && 'text-right'}
${(props) => props.readOnly && 'cursor-not-allowed'}
`;

type BaseCustomInputProps = {
  label?: string;
  value?: string | number;
  dataType?: 'text' | 'number';
  readonly?: boolean;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  containerClassName: string;
};

const BaseCustomInput: React.FC<BaseCustomInputProps> = ({
  label,
  value,
  dataType = 'text',
  readonly,
  onChange,
  containerClassName,
}) => {
  const [inputValue, setInputValue] = useState(value);

  useEffect(() => {
    setInputValue(value);
  }, [value]);

  return (
    <div className={containerClassName}>
      <label className="block text-xs font-medium text-primary-700">
        {label}
      </label>
      <div className="mt-1">
        <BaseInput
          value={inputValue}
          dataType={dataType}
          readOnly={readonly}
          type="text"
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
            setInputValue(e.target.value);
            if (onChange) {
              onChange(e);
            }
          }}
          hasError={false}
        />
      </div>
    </div>
  );
};

type Props = {
  label?: string;
  value?: string | number;
  dataType?: 'text' | 'number';
  readonly?: boolean;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
};

export const CustomInput: React.FC<Props> = (props) => {
  return <BaseCustomInput {...props} containerClassName="w-full" />;
};

export const CustomInputSm: React.FC<Props> = (props) => {
  return <BaseCustomInput {...props} containerClassName="w-24" />;
};

export const CustomInputMd: React.FC<Props> = (props) => {
  return <BaseCustomInput {...props} containerClassName="w-32" />;
};
